import { FirebaseOptions, initializeApp } from 'firebase/app';
import { getAuth, User } from 'firebase/auth';

const firebaseConfig = JSON.parse(process.env.FIREBASE_CONFIG || 'null') as FirebaseOptions;

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const getCurrentUser = (): Promise<User | null> => (
  new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    }, reject);
  })
);
